import axios from "axios";
import { useEffect, useState } from "react";

const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org";

export interface AddressProps {
  street?: string;
  number?: string;
  district?: string;
  city?: string;
  state?: string;
  region?: string;
  country?: string;
}

export const getCoordinatesFromAddress = async (props: AddressProps) => {
  let latitude: number = 0;
  let longitude: number = 0;

  const { street, number, district, city, state, region, country } = props;

  try {
    const formattedQuery = `${street ?? ""}+${number ?? ""}+${district ?? ""}+${city ?? ""}+${state ?? ""}+${region ?? ""}+${country ?? ""}`;

    const response = await axios.get(
      `${NOMINATIM_BASE_URL}/search?q=${formattedQuery}&format=json`
    );

    latitude = Number(response.data[0].lat);
    longitude = Number(response.data[0].lon);

    return [latitude, longitude];
  } catch (error) {
    console.error("Error fetching nominatim coordinates by address: ", error);
  }

  return null;
};

const fetchCoordinatesFromAdress = (props: AddressProps) => {
  const { city } = props;

  const [coordinates, setCoordinates] = useState([0, 0]);

  useEffect(() => {
    city &&
      getCoordinatesFromAddress(props)
        .then((response) => setCoordinates(response))
        .catch(() => console.log("ERRO COORD"));
  }, [city]);

  return { coordinates };
};

export default fetchCoordinatesFromAdress;
